import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOrdersOrderIdParams, TypeGetOrdersOrderIdResponse } from '~/types/delivery-agency.types';

const useGetOrdersOrderId = () => {
  const { runAsync } = useAsyncHandler();

  const getOrdersOrderId = useAPI<TypeGetOrdersOrderIdParams, TypeGetOrdersOrderIdResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_ORDER_DETAIL,
    method: 'get',
  });

  const requestOrderDetail = async (
    params: TypeGetOrdersOrderIdParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetOrdersOrderIdResponse['data']) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getOrdersOrderId({ pathParams: `/${params.orderId}` }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestOrderDetail };
};

export default useGetOrdersOrderId;
